import React from "react";

const CloseBar = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.43934 9.43836C10.0251 8.85258 10.9749 8.85258 11.5607 9.43836L27.117 24.9947C27.7028 25.5805 27.7028 26.5302 27.117 27.116C26.5312 27.7018 25.5815 27.7018 24.9957 27.116L9.43934 11.5597C8.85355 10.9739 8.85355 10.0241 9.43934 9.43836Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.117 9.43836C27.7028 10.0241 27.7028 10.9739 27.117 11.5597L11.5607 27.116C10.9749 27.7018 10.0251 27.7018 9.43934 27.116C8.85355 26.5302 8.85355 25.5805 9.43934 24.9947L24.9957 9.43836C25.5815 8.85258 26.5312 8.85258 27.117 9.43836Z"
        fill="black"
      />
    </svg>
  );
};

export default CloseBar;
